import { motion } from 'framer-motion';

import { getTextAnim, textProps, viewport } from '.';

function BodyText({
  customClass = '',
  color = 'white',
  bold = false,
  animate = true,
  initX = 0,
  finalX = 0,
  initY = 0,
  finalY = 0,
  fadeIn = true,
  delay = 0.1,
  children,
}) {
  let className = `${customClass} c-${color}`;
  if (bold) className += ` bold`;

  // If we are not animating, return a regular H4
  if (animate === false) return <h4 className={className}>{children}</h4>;

  const textAnim = getTextAnim(initX, finalX, initY, finalY, fadeIn, delay);
  return (
    <motion.h4
      className={className}
      variants={textAnim}
      initial="init"
      whileInView="after"
      viewport={viewport}
    >
      {children}
    </motion.h4>
  );
}

BodyText.propTypes = textProps;

export default BodyText;
